// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table3_container__ZxB4j {
  overflow-x: hidden;
  overflow-y: hidden;
}

.table3_container__ZxB4j table {
  max-width: auto;
  max-height: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  text-align: left;
}

.table3_body__Kk576 {
  overflow: auto;
}
.table3_header__Hntwl {
  text-align: center;
  color: #055437;
  font-weight: 600;
  font-size: 1em;
  /* display: table-header-group; */
  background: none !important;
  /* background-color: #055437 !important; */
}

.table3_header__Hntwl tr th {
  padding: 0.5em 2em;
}

.table3_head__I98rw {
  padding: 0.4em 0;
  justify-content: space-evenly;
}

.table3_data__e3mei {
  padding: 0.2em 2em;
  width: 100vw;
  font-weight: 500;
}

.table3_data__e3mei * {
  margin: 0;
}

.table3_actionButton__LBISE {
  background: none;
  border: none;
}

.table3_rowHeader__B-QD- td {
  font-weight: 800;
}
.table3_rowHeader__B-QD- td * {
  margin: 0;
}

.table3_monthContainer__a-cEF {
  overflow-x: scroll;
  overflow-y: scroll;
}

.table3_monthContainer__a-cEF table {
  max-width: 100%;
  height: 300px;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #055437;
}

.table3_monthHeader__9hgzp {
  color: white;
  font-weight: 600;
  font-size: 1em;
  display: table-header-group;
  background-color: #055437;
}

.table3_monthHeader__9hgzp tr th {
  padding: 0.5em 2em;
}

.table3_monthHead__20IMl {
  /* padding : .4em 0; */
  justify-content: space-between;
}

.table3_monthData__OBzq8 {
  text-align: center;
  padding: 0.2em 2em;
  width: 100vw;
  font-weight: 500;
  margin-left: 100px;
}

.table3_monthData__OBzq8 th {
  text-align: start;
  padding: 0.2em 2em;
  width: 100vw;
}

.table3_monthData__OBzq8 {
  text-align: end;
  padding: 0.2em 2em;
  width: 100vw;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/table3.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EAGjB,gBAAgB;AAFlB;;AAKA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".container {\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.container table {\n  max-width: auto;\n  max-height: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.container table {\n  text-align: left;\n}\n\n.body {\n  overflow: auto;\n}\n.header {\n  text-align: center;\n  color: #055437;\n  font-weight: 600;\n  font-size: 1em;\n  /* display: table-header-group; */\n  background: none !important;\n  /* background-color: #055437 !important; */\n}\n\n.header tr th {\n  padding: 0.5em 2em;\n}\n\n.head {\n  padding: 0.4em 0;\n  justify-content: space-evenly;\n}\n\n.data {\n  padding: 0.2em 2em;\n  width: 100vw;\n  font-weight: 500;\n}\n\n.data * {\n  margin: 0;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n}\n\n.rowHeader td {\n  font-weight: 800;\n}\n.rowHeader td * {\n  margin: 0;\n}\n\n.monthContainer {\n  overflow-x: scroll;\n  overflow-y: scroll;\n}\n\n.monthContainer table {\n  max-width: 100%;\n  height: 300px;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  border: 1px solid #055437;\n}\n\n.monthHeader {\n  color: white;\n  font-weight: 600;\n  font-size: 1em;\n  display: table-header-group;\n  background-color: #055437;\n}\n\n.monthHeader tr th {\n  padding: 0.5em 2em;\n}\n\n.monthHead {\n  /* padding : .4em 0; */\n  justify-content: space-between;\n}\n\n.monthData {\n  text-align: center;\n  padding: 0.2em 2em;\n  width: 100vw;\n  font-weight: 500;\n  margin-left: 100px;\n}\n\n.monthData th {\n  text-align: start;\n  padding: 0.2em 2em;\n  width: 100vw;\n}\n\n.monthData {\n  text-align: end;\n  padding: 0.2em 2em;\n  width: 100vw;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table3_container__ZxB4j`,
	"body": `table3_body__Kk576`,
	"header": `table3_header__Hntwl`,
	"head": `table3_head__I98rw`,
	"data": `table3_data__e3mei`,
	"actionButton": `table3_actionButton__LBISE`,
	"rowHeader": `table3_rowHeader__B-QD-`,
	"monthContainer": `table3_monthContainer__a-cEF`,
	"monthHeader": `table3_monthHeader__9hgzp`,
	"monthHead": `table3_monthHead__20IMl`,
	"monthData": `table3_monthData__OBzq8`
};
export default ___CSS_LOADER_EXPORT___;
